import { GlobalErrorBoundaryContext } from "@components/global-error-handler/global-error-context";
import { PlatformError } from "@components/platform-error/platform-error";
import { Box } from "@infinitaslearning/pixel-design-system";
import { useContext } from "react";

export const GlobalErrorAlert = ({ error }: { error: Error | undefined | null }) => {
  const { errorCaught } = useContext(GlobalErrorBoundaryContext);

  const isUncaughtError = error && errorCaught === null;

  const isNewErrorAfterBoundary =
    error && errorCaught !== null && !error?.message.includes(errorCaught?.message);

  return (
    (isNewErrorAfterBoundary || isUncaughtError) && (
      <Box
        style={{
          position: "fixed",
          zIndex: 9999,
          isolation: "isolate",
        }}
      >
        <PlatformError error={error} errorCode={0} />
      </Box>
    )
  );
};
